import qs from 'qs';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import { getDateRangeFromCalendar } from '../../shared/calendar';
import { getGroupValues } from '../../shared/groups';

export default (statisticsState) => {
	const { query, calendar, filters: { selectedFilters }, groups = null, table } = cloneDeep(statisticsState);
	let { sortMain, sortAdditional } = table;
	const dateRange = getDateRangeFromCalendar(calendar);

	if (dateRange) {
		query['date_range'] = dateRange;
	}

	if (selectedFilters) {
		const filters = {};

		selectedFilters.forEach(filter => {
			const values = filter.value.map(f => f.value);
			if (values.length) {
				filters[filter.name] = values;
			}
		});

		query['filters'] = !isEmpty(filters) ? filters : {};
	}

	if (groups) {
		const { listOfControls, orderControlsDuration } = groups;
		const groupValues = getGroupValues(listOfControls, orderControlsDuration);
		if (groupValues) {
			query['groups'] = groupValues;
			!groupValues.includes(sortMain && sortMain.index) && (sortMain = null);
			!groupValues.includes(sortAdditional && sortAdditional.index) && (sortAdditional = null);
		}
	}

	return qs.stringify({
		...query,
		sortMain,
		sortAdditional
	});
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/shared/get-invalid-request-query.js